import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getPerformerTiers, updatePerformerTiers } from '../api';

export const performerTierKeys = {
  all: ['performerTiers'],
};

export function usePerformerTiers(options = {}) {
  return useQuery({
    queryKey: performerTierKeys.all,
    queryFn: async () => {
      const res = await getPerformerTiers();
      return res.data;
    },
    // generalNotes ride this response and can be edited by pricers from My
    // Artists; refetch on focus + short staleness so admins see those edits
    // promptly (server side is SQLite + the warm inventory cache)
    staleTime: 60 * 1000,
    refetchOnWindowFocus: true,
    ...options,
  });
}

export function useUpdatePerformerTiers() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (assignments) => updatePerformerTiers(assignments),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: performerTierKeys.all });
    },
  });
}
